import React, { useRef } from 'react';
import './index.scss';

export const Button = ({
  name,
  children,
  className,
  onClick = () => {},
  type,
  isDisabled = false,
  ...props
}) => {
  const debounceTimeout = useRef(null);
  const btnName = name || children;
  let customClassName = 'button';
  if (className) {
    customClassName += ` ${className}`;
  }

  const handleClick = (event) => {
    if (debounceTimeout.current) {
      return;
    }
    onClick(event);
    debounceTimeout.current = setTimeout(() => {
      debounceTimeout.current = null;
    }, 2500);
  };

  return (
    <button
      type={type}
      className={customClassName}
      onClick={handleClick}
      {...props}
      disabled={isDisabled}
    >
      {btnName}
    </button>
  );
};

export default Button;
